module.exports = __webpack_public_path__ + "img/img-widget-report.e29c4a14.svg";